import { DatePicker, Divider, Form, Switch, TimePicker } from "antd";
import { useState } from "react";
import useSurvey from "../../../pages/surveys/hooks/useSurvey";
import styles from "../styles/styles.module.css";
import moment from "moment";

const SurveyDuration = ({ surveyInfo, getSurveyInfoHandler }) => {
  const [isSurveyDurationEnabled, setIsSurveyDurationEnabled] = useState(
    !!surveyInfo?.scheduled
  );
  const [form] = Form.useForm();
  const { saveSurveyDuration, changeSwitchDuration } = useSurvey();
  const [startDate, setStartDate] = useState(surveyInfo?.available_from);
  const [endDate, setEndDate] = useState(surveyInfo?.available_until);
  const [startTime, setStartTime] = useState(surveyInfo?.available_from);
  const [endTime, setEndTime] = useState(surveyInfo?.available_until);

  const onFinish = async (values) => {
    if (!surveyInfo) return;
    console.log("Form values:", values);

    await saveSurveyDuration({
      id_survey: surveyInfo.id,
      available_from: `${moment(values.start_date).format(
        "YYYY-MM-DD"
      )} ${moment(values.start_time).format("HH:mm:ss")}`,
      available_until: `${moment(values.end_date).format(
        "YYYY-MM-DD"
      )} ${moment(values.end_time).format("HH:mm:ss")}`,
    });

    await getSurveyInfoHandler(surveyInfo.id);
  };

  const disabledStartDate = (current) => {
    return current && endDate && current > endDate;
  };

  const disabledEndDate = (current) => {
    return current && startDate && current < startDate;
  };

  const disabledStartTime = () => {
    if (
      moment(startDate).isValid() &&
      moment(endDate).isValid() &&
      moment(startDate).isSame(endDate, "day") &&
      moment(endTime).isValid()
    ) {
      const endHour = moment(endTime).hour();
      const endMinute = moment(endTime).minute();
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter((h) => h > endHour),
        disabledMinutes: (selectedHour) =>
          selectedHour === endHour
            ? Array.from({ length: 60 }, (_, i) => i).filter(
                (m) => m > endMinute
              )
            : [],
      };
    }
    return {};
  };

  const disabledEndTime = () => {
    if (
      moment(startDate).isValid() &&
      moment(endDate).isValid() &&
      moment(startDate).isSame(endDate, "day") &&
      moment(startTime).isValid()
    ) {
      const startHour = moment(startTime).hour();
      const startMinute = moment(startTime).minute();
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter((h) => h < startHour),
        disabledMinutes: (selectedHour) =>
          selectedHour === startHour
            ? Array.from({ length: 60 }, (_, i) => i).filter(
                (m) => m < startMinute
              )
            : [],
      };
    }
    return {};
  };

  return (
    <div className={styles["survey-page-list"]}>
      <header className={styles["survey-duration-header"]}>
        <h3>Duración de encuesta</h3>
        <Switch
          onChange={async (value) => {
            if (!surveyInfo?.id) return;

            changeSwitchDuration(surveyInfo.id);

            form.resetFields();
            setIsSurveyDurationEnabled(value);
          }}
          checked={isSurveyDurationEnabled}
          size="small"
        />
      </header>

      <p className={styles["survey-duration-description"]}>
        Fecha de inicio / de vencimiento cuando su encuesta estará accesible y
        recogerá las respuestas
      </p>

      <Form
        onFinish={onFinish}
        form={form}
        layout="vertical"
        initialValues={{
          start_date: moment(surveyInfo?.available_from).isValid()
            ? moment(new Date(surveyInfo.available_from))
            : undefined,
          end_date: moment(surveyInfo?.available_until).isValid()
            ? moment(new Date(surveyInfo.available_until))
            : undefined,
          start_time: moment(surveyInfo?.available_from).isValid()
            ? moment(new Date(surveyInfo.available_from))
            : undefined,
          end_time: moment(surveyInfo?.available_until).isValid()
            ? moment(new Date(surveyInfo.available_until))
            : undefined,
        }}
      >
        <Form.Item
          rules={[
            {
              required: true,
              message: "Este campo es requerido",
            },
          ]}
          style={{ marginBottom: 8 }}
          label="Fecha inicio"
          name={"start_date"}
        >
          <DatePicker
            disabledDate={disabledStartDate}
            onChange={(value) => {
              form.submit();
              setStartDate(value);
            }}
            format={"DD/MM/YYYY"}
            style={{ width: "100%" }}
            disabled={!isSurveyDurationEnabled}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: "Este campo es requerido",
            },
            // {
            //   validator: (_, value) => {
            //     if (
            //       isSurveyDurationEnabled &&
            //       moment(startDate).isValid() &&
            //       moment(endDate).isValid() &&
            //       moment(startTime).isValid() &&
            //       moment(endTime).isValid() &&
            //       moment(startDate).isSame(endDate, "day") &&
            //       moment(value).isAfter(endTime)
            //     ) {
            //       return Promise.reject(
            //         "La hora de inicio no puede ser mayor que la de finalización"
            //       );
            //     }
            //     return Promise.resolve();
            //   },
            // },
          ]}
          style={{ marginBottom: 0 }}
          label="Hora inicio"
          name={"start_time"}
        >
          <TimePicker
            disabledTime={disabledStartTime}
            onChange={(value) => {
              form.submit();
              setStartTime(value);
            }}
            style={{ width: "100%" }}
            format="hh:mm A"
            use12Hours
            disabled={!isSurveyDurationEnabled}
          />
        </Form.Item>

        <Divider style={{ color: "#B6C2E2" }} dashed />

        <Form.Item
          rules={[
            {
              required: true,
              message: "Este campo es requerido",
            },
          ]}
          style={{ marginBottom: 8, marginTop: 0 }}
          label="Fecha finalización"
          name={"end_date"}
        >
          <DatePicker
            disabledDate={disabledEndDate}
            onChange={(value) => {
              form.submit();
              setEndDate(value);
            }}
            format={"DD/MM/YYYY"}
            style={{ width: "100%" }}
            disabled={!isSurveyDurationEnabled}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: "Este campo es requerido",
            },
            {
              validator: (_, value) => {
                if (
                  isSurveyDurationEnabled &&
                  moment(startDate).isValid() &&
                  moment(endDate).isValid() &&
                  moment(startTime).isValid() &&
                  moment(value).isBefore(startTime) &&
                  moment(startDate).isSame(endDate, "day")
                ) {
                  return Promise.reject(
                    "La hora de finalización no puede ser menor que la de inicio"
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
          style={{ marginBottom: 0 }}
          label="Hora finalización"
          name={"end_time"}
        >
          <TimePicker
            disabledTime={disabledEndTime}
            onChange={(value) => {
              form.submit();
              setEndTime(value);
            }}
            style={{ width: "100%" }}
            format="hh:mm A"
            use12Hours
            disabled={!isSurveyDurationEnabled}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default SurveyDuration;
